import { useFormik } from "formik";
import React, { useState } from "react";
import UseFetchReportData from "../../../../../Components/Hooks/useFetchReportData";
import useFetchMataData from "../../../../../Components/Hooks/useFetchMataData";
import FormikSelectTwo, {
  FormikSelectTwoSmall,
} from "../../../../../Components/Utils/Select";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../../Components/Utils/Buttons";
import { NuDate, NuDateSmall } from "../../../../../Components/Utils/Input";
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb";
import NewReportTable from "../../../../../Components/Others/NewReportTable";
import {
  DownloadPDF,
  DownloadXLXS,
} from "../../../../../Components/Utils/Download";

function TaskReport() {
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState(false);

  const headers = [
    {
      title: "Ref",
      width: "10%",
      field: "sno",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Activity",
      width: "10%",
      field: "Activity",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Priority",
      width: "10%",
      field: "Priority",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Assignee",
      width: "10%",
      field: "Assignees",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Start Date",
      width: "10%",
      field: "StartDate",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },

    {
      title: "Completed on",
      width: "10%",
      field: "CompleteOn",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "Status",
      width: "10%",
      field: "Status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];

  const [filterProps, setFilterProps] = useState({
    status: "",
    dateFrom:"",
    dateTo:"",
    priority:""
  });

  const [params, setParams] = useState({
    status: "",
    dateFrom:"",
    dateTo:"",
    priority:""
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
      setParams({
        status: value.status,
        dateFrom:value.dateFrom||"",
        dateTo:value.dateTo||"",
        priority:value.priority||""
      });
      setTimeout(() => {
        setFilter(true);
        // closeFilterDialog();
      }, 1000);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/xlsx-report/filter-task",
    params
  );

  function closeFilterDialog() {
    setShowFilter(false);
    formik.resetForm();
    setFilter(false);
    setParams({
      status: "",
    });
  }

  const { value: status, getData: refstatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Task"
  );

  const { value: Priority, getData: refPriority } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "priority"
  );
  return (
    <>
      <div className="w-full h-full py-2 px-4  overflow-hidden">
        <div className="flex justify-between w-full ">
          <Breadcrumb
            items={[
              {
                name: "Report",
                link: "/report",
              },
              { name: "Task" },
            ]}
          />
          <BackButton />
        </div>
        <div className="w-[100%] h-[calc(100vh-135px)] mt-2 bg-white rounded-lg px-3 pb-1 overflow-y-auto">
          <div className="flex gap-x-2 justify-between  w-full  py-2">
            <div className=" max-w-[300px] pr-7 ">
              <p className=" font-semibold text-xs 2xl:text-sm  ">
                Task Report : {data?.length}
              </p>
            </div>
            <div className=" flex-1 ">
              <form onSubmit={formik.handleSubmit}>
                <div className=" w-full grid grid-cols-5  gap-3">
                  <NuDateSmall
                    label="From "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="dateFrom"
                    width="w-full"
                  />
                  <NuDateSmall
                    label="To "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="dateTo"
                    width="w-full"
                  />

                  <FormikSelectTwoSmall
                    label="Priority"
                    Options={Priority}
                    formik={formik}
                    placeholder="Choose"
                    name="priority"
                    width="w-full"
                    displayProperty={"Priority"}
                    propertyName={"priority"}
                    getFunc={refPriority}
                  />

                  <FormikSelectTwoSmall
                    label="Status"
                    Options={status}
                    formik={formik}
                    placeholder="Choose"
                    name="status"
                    width="w-full "
                  />
                  <div className=" w-full flex justify-end ">
                    <div className=" w-full flex items-end gap-2">
                      <SubmitButton name="Apply" />
                      <CancelButton
                        label="Clear"
                        handleClick={closeFilterDialog}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className=" w-[80px] flex justify-end items-end gap-4 ">
              <DownloadPDF
                url={`/xlsx-report/export-tasks-excel`}
                fileName="Task Report"
                params={params}
              />
              <DownloadXLXS
                url={`/xlsx-report/export-tasks-pdf`}
                fileName="Task Report"
                params={params}
              />
            </div>
          </div>
          <NewReportTable
            headers={headers}
            data={data}
            dataLoading={dataLoading}
          />
        </div>
      </div>
    </>
  );
}

export default TaskReport;
